jQuery(document).ready(function() {
    if(!jQuery('.single-item-wrapper')[0]) return;
    var onResize = function() {
    }

    var onScroll = function() {
       
    }
    onResize()
    jQuery(window).scroll(onScroll)
    jQuery(window).resize(onResize);
})







